import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [signupAnimating, setSignupAnimating] = useState(false);
  const [loginAnimating, setLoginAnimating] = useState(false);
  const [blurIntensity, setBlurIntensity] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const maxBlur = 20; // Maximum blur in pixels
      const blurDistance = 200; // Distance over which blur changes
      
      // Calculate blur intensity based on scroll position
      const blur = Math.min(scrollY / blurDistance * maxBlur, maxBlur);
      setBlurIntensity(blur);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleButtonClick = (setAnimating: React.Dispatch<React.SetStateAction<boolean>>) => {
    setAnimating(true);
    setTimeout(() => setAnimating(false), 1000);
  };

  return (
    <header 
      className="fixed top-0 left-0 right-0 z-50 border-b border-gray-200/20 transition-all duration-300"
      style={{
        backdropFilter: `blur(${blurIntensity}px)`,
        backgroundColor: `rgba(255, 255, 255, ${blurIntensity / 40})`
      }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 sm:py-6 flex items-center justify-between">
        <a href="/" className="flex items-center">
          <img src="/logos/main logo@3x.png" alt="Relatable" className="h-8 sm:h-12" />
        </a>
        
        <div className="flex gap-2 sm:gap-6 items-center">
          <a 
            href="https://www.relatable.one/signup" 
            className={`font-sans text-white transition-all duration-200 hover:scale-110 hover:font-semibold px-3 sm:px-4 py-2 rounded-lg shadow-sm text-sm sm:text-base ${signupAnimating ? 'animate__animated animate__tada' : ''}`}
            style={{
              backgroundColor: 'var(--primary-color)',
              '--tw-bg-opacity': '1'
            } as React.CSSProperties}
            onMouseEnter={(e) => {
              setSignupAnimating(true);
              e.currentTarget.style.backgroundColor = 'var(--primary-hover)';
            }}
            onMouseLeave={(e) => {
              setSignupAnimating(false);
              e.currentTarget.style.backgroundColor = 'var(--primary-color)';
            }}
            onClick={() => handleButtonClick(setSignupAnimating)}
          >
            Sign up
          </a>
          <a 
            href="https://www.relatable.one/login" 
            className={`font-sans bg-white transition-all duration-200 hover:scale-110 hover:font-semibold px-3 sm:px-4 py-2 rounded-lg shadow-sm text-sm sm:text-base ${loginAnimating ? 'animate__animated animate__tada' : ''}`}
            style={{
              color: 'var(--primary-color)',
              border: '1px solid var(--primary-color)'
            } as React.CSSProperties}
            onMouseEnter={(e) => {
              setLoginAnimating(true);
              e.currentTarget.style.backgroundColor = 'var(--primary-lighter)';
              e.currentTarget.style.borderColor = 'var(--primary-hover)';
            }}
            onMouseLeave={(e) => {
              setLoginAnimating(false);
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.borderColor = 'var(--primary-color)';
            }}
            onClick={() => handleButtonClick(setLoginAnimating)}
          >
            Log In
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header; 